module.exports = __webpack_public_path__ + "img/hr-stack-filter-inserter-hand-closed.a4f73085.png";